import { Button, ButtonProps } from '@mui/material'
import React from 'react'
import useButtonStyles from '../../../styles/useButtonStyles'


interface Props extends ButtonProps { }

const AppButton: React.FC<Props> = ({
    children,
    ...props
}) => {
    const classes = useButtonStyles()

    return (
        <Button classes={classes} {...props}>{children}</Button>
    )
}

export default AppButton
